import type { LDContext } from '../types/types';

/**
 * Get the value of a specific attribute from a context.
 * @param context - The context to get the attribute from.
 * @param attribute - The name of the attribute to get.
 * @returns The value of the attribute, or an empty string if not found.
 */
export function getContextAttributeValue(context: LDContext, attribute: string): string {
  if (attribute in context) {
    return String(context[attribute as keyof LDContext]);
  }
  return '';
}
